module.exports = __webpack_public_path__ + "static/media/tumb6.1ccc7ef3.png";